import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDate,
  InMemoryInteger,
} from "pbas-vue-components";
import { translate2 } from "../trans2";

const InMemoryCoverageHeaders = [
  // new InMemoryHeader({
  //   type: new InMemoryString("Id"),
  //   visible: false,
  //   isIdentifier: true,
  //   allowVisibilityChange: false,
  // }),
  new InMemoryHeader({
    type: new InMemoryString("Identifier"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    type: new InMemoryString("IdentityId"),
    visible: false,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    type: new InMemoryString("Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    type: new InMemoryString("Name"),
    visible: false,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "globals.name",
    type: new InMemoryString("Translations[]/Name", {
      getString: (item) => translate2(item, "Name"),
    }),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
    orderByKey: "Name",
  }),
  new InMemoryHeader({
    title: "globals.order",
    type: new InMemoryInteger("Order"),
    visible: true,
    allowVisibilityChange: true,
    sortable: true,
    searchable: true,
    orderByKey: "Order",
  }),
  new InMemoryHeader({
    type: new InMemoryString("Description"),
    visible: false,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "globals.description",
    type: new InMemoryString("Translations[]/Description", {
      getString: (item) => translate2(item, "Description"),
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
    orderByKey: "Description",
  }),
  new InMemoryHeader({
    type: new InMemoryString("PlanInsuranceCarrierId"),
    visible: false,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    type: new InMemoryString("TrustFundId"),
    visible: false,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "components.inmemorydependants.effective_date",
    type: new InMemoryDate("EffectiveDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "views.coverage.brokered_by",
    type: new InMemoryString("Broker", {
      getString: (item) => {
        if (item.Broker) {
          return `${item.Broker.FirstName} ${item.Broker.LastName}`;
        }
        return "";
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
    orderByKey: "TrustFund/Name",
  }),
];

export default InMemoryCoverageHeaders;
